export enum FileStatus {
    UPLOADED = 1,
    PENDING = 2,
}